import clsx from 'clsx'
import { C1Icon } from 'components/core/icons/C1Icon'
import { CircleCheck, Info, Pencil, PieChart } from 'lucide-react'
import React from 'react'
import { useStyles } from './styles'

type AccessReviewStatusIconProps = {
    className?: string
    iconSize?: 'small' | 'inherit' | 'medium' | 'large'
}

const mapIconSize = (iconSize?: 'small' | 'inherit' | 'medium' | 'large'): 'sm' | 'md' | 'lg' | undefined => {
    switch (iconSize) {
        case 'small':
            return 'sm'
        case 'medium':
        case 'inherit':
            return 'md'
        case 'large':
            return 'lg'
        default:
            return undefined
    }
}

export const AccessReviewStateFacetIconOpen = ({ className, iconSize }: AccessReviewStatusIconProps): React.ReactElement => {
    const classes = useStyles()
    if (!className) {
        className = classes.icon
    }
    return <C1Icon icon={PieChart} size={mapIconSize(iconSize)} aria-label="open" className={clsx(className, classes.open)} />
}

export const AccessReviewStateFacetIconPending = ({
    className,
    iconSize,
}: AccessReviewStatusIconProps): React.ReactElement => {
    const classes = useStyles()
    if (!className) {
        className = classes.icon
    }
    return <C1Icon icon={Pencil} size={mapIconSize(iconSize)} aria-label="pending" className={clsx(className, classes.purple)} />
}

export const AccessReviewStateFacetIconUnspecified = ({
    className,
    iconSize,
}: AccessReviewStatusIconProps): React.ReactElement => {
    const classes = useStyles()
    if (!className) {
        className = classes.icon
    }
    return (
        <C1Icon icon={Info} size={mapIconSize(iconSize)} aria-label="unspecified" className={clsx(className, classes.unspecified)} />
    )
}

export const AccessReviewStateFacetIconClosed = ({ className, iconSize }: AccessReviewStatusIconProps): React.ReactElement => {
    const classes = useStyles()
    if (!className) {
        className = classes.icon
    }
    return <C1Icon icon={CircleCheck} size={mapIconSize(iconSize)} aria-label="closed" className={clsx(className, classes.purple)} />
}
